module.exports = __webpack_public_path__ + "img/pic6.292b63a1.jpg";